export default __webpack_public_path__ + "static/media/chim7.07d8c366.webp";